function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as l } from "../../hooks.js";
import { useIsInverseVariant as i } from "../../theme-variant-context.js";
import { vars as e } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: t , size: c = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = i(), a = t !== null && t !== void 0 ? t : n ? e.colors.inverse : e.colors.neutralHigh, { skinName: s  } = l();
    return s.match(/^o2/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: a,
            d: "M11.897 2c.375 0 .68.321.68.715v11.174c.987.321 1.703 1.249 1.703 2.393 0 1.145-.716 2.072-1.702 2.393v2.606c0 .394-.306.715-.681.715-.375 0-.681-.321-.681-.715v-2.606c-.987-.32-1.702-1.248-1.702-2.393 0-1.144.715-2.072 1.702-2.393V2.715c0-.394.306-.715.68-.715zm.003 13.21c-.577 0-1.02.466-1.02 1.072 0 .607.443 1.072 1.02 1.072.578 0 1.022-.465 1.022-1.072 0-.606-.444-1.072-1.022-1.072zM17 2c.375 0 .68.321.68.715V6.75c.988.321 1.703 1.249 1.703 2.393 0 1.14-.715 2.068-1.698 2.39v9.752c0 .394-.306.715-.681.715-.375 0-.681-.321-.681-.715v-9.749c-.987-.321-1.702-1.248-1.702-2.393 0-1.144.715-2.072 1.702-2.393V2.715c0-.394.302-.715.677-.715zm.004 6.067c-.578 0-1.021.466-1.021 1.072 0 .606.443 1.072 1.02 1.072.578 0 1.018-.462 1.022-1.072 0-.606-.444-1.072-1.021-1.072zM6.999 2c.375 0 .68.321.68.715V6.75c.989.321 1.704 1.25 1.704 2.393 0 1.14-.715 2.068-1.698 2.39v9.752c0 .394-.306.715-.681.715-.375 0-.681-.321-.681-.715v-9.749c-.987-.321-1.702-1.248-1.702-2.393 0-1.144.715-2.072 1.702-2.393V2.715C6.323 2.321 6.625 2 7 2zm.004 6.067c-.578 0-1.021.466-1.021 1.072 0 .606.443 1.072 1.02 1.072.578 0 1.018-.462 1.022-1.072 0-.606-.444-1.072-1.021-1.072z"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: a,
            d: "M2.195 5.693c.003.33.275.594.602.59h1.048l.002.021a.283.283 0 00.006.042c.18.767.656 1.428 1.328 1.84a3.02 3.02 0 002.266.38 2.967 2.967 0 001.88-1.299c.193-.3.328-.63.398-.98h11.5a.597.597 0 00.603-.591.599.599 0 00-.602-.591H9.722a.215.215 0 01-.002-.025c0-.012 0-.025-.004-.037a2.912 2.912 0 00-1.328-1.84 3.022 3.022 0 00-2.266-.381 2.996 2.996 0 00-1.88 1.3 2.89 2.89 0 00-.394.983h-1.05a.595.595 0 00-.603.588zm2.832.392a1.735 1.735 0 01.233-1.333A1.823 1.823 0 017.747 4.2c.403.246.689.644.795 1.104.107.462.023.935-.232 1.333-.26.4-.658.678-1.129.781a1.8 1.8 0 01-1.358-.23 1.762 1.762 0 01-.796-1.103zm12.151 7.69c-.994 0-1.804-.796-1.804-1.768 0-.975.81-1.768 1.804-1.768.995 0 1.804.793 1.804 1.768 0 .974-.81 1.767-1.804 1.767zm4.628-1.768a.595.595 0 00-.603-.591v-.003H20.12c-.277-1.342-1.492-2.356-2.944-2.356-1.45 0-2.663 1.014-2.944 2.356H2.773a.597.597 0 00-.602.59.597.597 0 00.602.592h11.462c.28 1.342 1.493 2.356 2.944 2.356 1.451 0 2.667-1.014 2.944-2.356h1.081a.595.595 0 00.603-.588zm-12.33 8.061c-.995 0-1.805-.793-1.805-1.767 0-.975.81-1.768 1.804-1.768.995 0 1.804.793 1.804 1.768s-.81 1.767-1.804 1.767zm12.327-1.765a.595.595 0 00-.602-.59l-8.782.002c-.28-1.341-1.493-2.355-2.944-2.355-1.45 0-2.664 1.014-2.944 2.355H2.772a.595.595 0 00-.602.588.598.598 0 00.602.592h3.76c.28 1.341 1.492 2.355 2.943 2.355s2.664-1.014 2.944-2.355h8.782a.597.597 0 00.602-.591z"
        })
    }));
}, z = h;
export { z as default };
